module.exports = __webpack_public_path__ + "static/1-87d990f3f1ed29515bddddfda4cff9f1.jpg";